var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"item",attrs:{"to":_vm.to}},[(_vm.show)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }